import { FEED_PAGE_URLS, WP_BLOGS } from '@wix/communities-blog-client-common';
import { blogAppDefId } from '@app/external/common/constants/apps';
import { type PlatformApi } from '@app/external/common/controller/platform-api';

export const getSectionUrl = async ({
  platformApi,
  instanceId,
  sectionId,
}: {
  platformApi: PlatformApi;
  instanceId: string;
  sectionId: string;
}) => {
  if (WP_BLOGS.includes(instanceId)) {
    return FEED_PAGE_URLS[instanceId];
  }

  const { url } = await platformApi.site.getSectionUrl({
    sectionId,
    appDefinitionId: blogAppDefId,
  });
  return url?.split('?')[0] ?? '';
};
